﻿import React from 'react';

class ButtonArea extends React.Component {

    constructor(props) {
        super(props);
        //console.log("ButtonArea props: ", props)
    }

    render() {

        return (
            <div className="button-area">
                {
                    this.props.Buttons.map((button, idx) => {

                        let icon= (button.Icon && button.Icon.SmallIcon) ? <span  dangerouslySetInnerHTML={{ __html: button.Icon.SmallIcon }}></span>
                                    : null;

                        let target = button.Link.Target ? button.Link.Target : "_self";
                        let cNames = "button u-margin-top-small";
                        if(button.Tracking.AddTrackingClass) {
                            cNames += " btn-track"
                        }
                        if(button.Type && button.Type === "hollow") {
                            cNames += " button--hollow"
                        }

                        let myId = {}
                        if(button.Tracking.TrackingId && button.Tracking.TrackingId !== "") {
                            myId = {'id': button.Tracking.TrackingId}
                        }

                        return <a href={button.Link.Url} 
                            className={cNames} 
                            target={target} 
                            key={idx} 
                            data-action={button.Tracking.EventAction} 
                            data-category={button.Tracking.EventCategory} 
                            data-label={button.Tracking.EventLabel} {...myId}>
                            {icon}
                            <span>{button.Link.Title}</span>
                        </a>
                    })
                }
            </div>
        )
    }
}

export default ButtonArea;